// Carved verbatim from `src/features/agent-harness/hooks.ts` (ARCFE-1079 · D4).
// Takes no `transport`: the pre-move body called the module-level
// `setAgentRunApprovalMode` from `client.ts`, which is itself a re-export of
// this package's `data/api/harness.ts`. It is imported directly here, so the
// call reaches the same carved function through one fewer hop rather than
// through an app-side re-export.
import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { ApprovalMode } from '../../contracts/harness.types';
import { agentHarnessKeys } from '../../contracts/keys';
import { setAgentRunApprovalMode } from '../api/harness';

export const useMutateSetApprovalMode = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      agentRunId,
      approvalMode,
    }: {
      agentRunId: string;
      approvalMode: ApprovalMode;
    }) => setAgentRunApprovalMode(agentRunId, approvalMode),
    onSuccess: (_data, { agentRunId }) => {
      void queryClient.invalidateQueries({
        queryKey: agentHarnessKeys.run(agentRunId),
      });
    },
  });
};
